import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { Globals } from 'src/app/service/global';
import { environment, environment_const } from 'src/environments/environment';
import { UtilityService } from 'src/app/service/utility.service';
import { PermissionService } from 'src/app/service/permission.service';
import { HistoryComponent } from '../history/history.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';

declare var CKEDITOR: any;

@Component({
  selector: 'app-instant-meeting-followup-task',
  templateUrl: './instant-meeting-followup-task.component.html',
  styleUrls: ['./instant-meeting-followup-task.component.css'],
  providers: [UtcDatePipe]
})
export class InstantMeetingFollowupTaskComponent implements OnInit,AfterViewInit {

    //UI Team variable declaration
    @Input() pinDialogTriggered = false;
    @Input()videoSectionStatusChecker : any
    @Input() contentEditableBoolmin : any=true;
    collabVariable = 'active'
    @Input()hideParts: any
  
    @Input()
    deviceXs!: boolean;
  
    @Input()
    deviceSm!: boolean;
  
    @Input()
    deviceMd! : boolean;
  
    @Input()
    deviceLg! : boolean;
  
    @Input()
    deviceXl! : boolean;
  
    //padlock variable
    padlock :any;
    matDialogRefs!: MatDialogRef<AttachmentDialogComponent>;
    matDialogRef!: MatDialogRef<AgendaTaskEditDialogComponent>;
    taskStatusList: any;
    taskStatusCode = new UntypedFormControl();
    isPrivate: any;
    showToolTip = false;
    taskCompleted :any ;
    agendaAttachResp: any;
    attachCount: boolean =true;
    attachmentCount: any;
    attachmentTotalCnt: any = true;
    attachmentIcon = 'Y';
    decryptKey: string = '';
    @Input() meetingResponse:any
    //@Output() isTaskAddedOrModified : any = new EventEmitter();
  disaleAttachmentFileIcon: any;
  taskInfo: any;
  toLinkingNotes: any;
  agendasinfoe: any;
    constructor(public freeFormAgenda:FreeFormAgendaService,private readonly breakpointObserver: BreakpointObserver,private utility:UtilityService,private permissionService:PermissionService,private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, private matDialog: MatDialog, public attachService: AttachmentService, public commonAgService: FreeFormAgendaService, private meetingService: MeetingService,private historyDialogService:HistoryDialogService) {
      this.taskStatusList = this.globals.globaltaskStatusList;
    }
    @Input() minAttrList: any;
    taskDetails: any;

    isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.XSmall
      );
      isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Medium
      )
      isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Small
      )

    ngOnInit(): void {
     var padLockValue = this.minAttrList.isPrivate;
    
  
    // this.taskStatusCode.setValue(this.minAttrList.followUpTaskInfo.status)
      if(padLockValue == 'Y'){
        this.padlock = true;
      }else{
        this.padlock = false;
      }
      this.setCurrentStatusCodeByStatus();

      
    }
    ngAfterViewInit() {
     this.commonMinService.activateAllCkeditor('agChildTask');
     this.setCurrentStatusCodeByStatus();

    }
    handleMouseUp(noteElement: HTMLDivElement): void {
      const selection = window.getSelection();
      if (selection && selection.toString()) {
        noteElement.setAttribute('highlightIndex', '0');
      }
    }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    noteElement.setAttribute('highlightIndex', '0'); 
  }
  
  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    this.commonAgService.trackChangesWhileEditing(
      noteElement.getAttribute('taskId')!,
      noteElement.getAttribute('agId')!,
      event,
      noteElement.getAttribute('entityType')!,
      'agMinId' + noteElement.getAttribute('taskId')
    );
        if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
        event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }
  
  highlightNextText(noteElement: HTMLDivElement): void {
    // const regex = /\[XXXXXX\]/gi;
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;
  
    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());
  
    this.applyHighlight(noteElement, matches, currentIndex);
  }
  
  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;
  
    const selection = window.getSelection();
    const range = document.createRange();
    
    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;
  
  
    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;
  
      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;
        
        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));
  
        found = true;
        break;
      }
  
      offset += nodeLength;
    }
  
    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }
    getTooltipValue(): string {
      const selectedStatus = this.taskStatusList.find((data: { code: any; }) => data.code === this.taskStatusCode.value);
      return selectedStatus ? selectedStatus.description : 'Task';
    }
    ngOnChanges(event : any){
      this.setCurrentStatusCodeByStatus();
    }
    createEmptyAgenda(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.AGENDA,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var newAg='AG'
      this.commonAgService.trackAgendaEventOnClick(event,newAg);
  
    }
    createEmptyNote(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/nn";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    createEmptyTask(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.TASK,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/tt";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    createEmptyDecision(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/dd";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    getMinComStatusCode(){

      if(this.meetingResponse.commonMomStatusCode == 'A'){
        this.disaleAttachmentFileIcon = false;
      }
    }

    
    ngOnDestroy(){
      // for (var instance in CKEDITOR.instances) {
      //   CKEDITOR.instances[instance].destroy();
      // }
    }

    setCurrentStatusCodeByStatus(){
      var statusCode = "";
      this.taskStatusList.forEach((data : any) => {
        if(data.codeId == this.minAttrList.followUpTaskInfo.status){
          statusCode = data.code
        }
      });
      
      this.taskStatusCode.setValue(statusCode)
    }
  
    statusTracker(id : any, vari : any){
      if(vari == 'active'){
        let element = (<HTMLElement>document.getElementById("agMinId"+id))
        element.contentEditable = 'false'
      }
      else if(vari == 'inActive'){
        let element = (<HTMLElement>document.getElementById("agMinId"+id))
        element.contentEditable = 'true'
      }
    }
  
    // used to open task edit dialog box
    taskEditDialog(curTaskUiInfo:any) {
      //
      var taskId = curTaskUiInfo.taskId;
      if(curTaskUiInfo.isFollowUpFlag=='Y'){
        taskId=curTaskUiInfo.prevMinuteId;
      }
      this.meetingService.fetchTaskInfo(taskId).subscribe(
        (meetingRes: any) => {
          this.taskDetails = meetingRes.body
         this.matDialogRef = this.matDialog.open(AgendaTaskEditDialogComponent, { data: {taskData :  meetingRes.body,curTaskUiInfo:curTaskUiInfo}, panelClass: ['animate__animated','animate__slideInLeft'],
          disableClose: true,
          position : {
            left : "0%"
          },
         
          maxHeight: "100vh",
          width: "50%",
          height : "100vh" });
          this.matDialogRef.afterClosed().subscribe(respValue => {
            this.commonAgService.curStatus$.subscribe(resp => {
              if(this.minAttrList.prevMinuteId == resp.minutesId){
               this.minAttrList.followUpTaskInfo.status = resp.status;
               this.setCurrentStatusCodeByStatus();
              }
             });
            // //
            // respValue = this.minAttrList
          });
        });
      }

 //attachment dialog

 openConfidentialDialog(e : any, m : any) {
    
  this.dialog.open(AttachmentDialogComponent,{
  data:{e,m, "data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
   panelClass: ['animate__animated','animate__slideInLeft'],
               disableClose: true,
               position : {
                 left : "0%"
               },
              
               maxHeight: "100vh",
               width: "50%",
               height : "100vh"
 }).afterClosed().subscribe((response: any) => {
   this.meetingService.fetchTaskInfo(e.followUpTaskInfo._id).subscribe((data: any) => {
     
     if (data != undefined) {
       var minAttrList = this.minAttrList;
       if (minAttrList != null) {
        this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
        this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,environment.noteEntityType);
       }
      }
   });
 });
 //
}

trackChanges(id : any){
  this.showToolTip = true;
  //
  let elementCreation = document.getElementById('agMinId'+id);
  $('#agMinId'+id).css("border","5px solid rgba(0,0,0,.12)")
}

removeTrackChanges(id : any){
  $('#agMinId'+id).css("border","0px")
  this.showToolTip = false
  //this.isTaskAddedOrModified.emit(this.minAttrList);
}

//used to update common task status
overAllTaskStatusUpdate(e: any) {
  var statusCode : any
    this.taskStatusList.forEach((data : any) => {
      if(data.code == this.taskStatusCode.value){
        statusCode = data.codeId
        e.status = statusCode; 
      }
    })
  this.commonMinService.updateOverAllTaskStatus(e,this.minAttrList,statusCode);

}

  //agenda link dialog

  addNewLink(entityId:any, meetingId:any) {
    this.dialog.open(AddLinkDialogComponent, {
      data:{entityId,meetingId,"entityType":"AI","attachmentMode":"LI","data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    }).afterClosed().subscribe((response: any) => {
      this.meetingService.fetchTaskInfo(entityId).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'AI');
          }
         }
      });
    });
  }
  getAttachCount(e:any){
    
     this.meetingService.fetchTaskInfo(e.followUpTaskInfo.taskId).subscribe((data: any) => { 
      this.agendaAttachResp = data.body;
      
      this.attachCount = false;
   });  
  }
  history(entityId:any,modifiedName:any) {
    var entityType ='AI';
    this.historyDialogService.openHistoryDialog(entityId,entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  } 
 openLinkToNoteDialog(meetingId?: number): void {
     const id =  this.minAttrList.followUpTaskInfo.meetingId;
     const decryptKey = this.minAttrList?.decryptKey;
 
  
     if (!id || !this.minAttrList?.followUpTaskInfo.taskId) {
       console.error('Meeting ID or Task ID is not defined');
       return;
     }
   
     // Step 1: Fetch task info first
     this.meetingService.fetchTaskInfo(this.minAttrList.followUpTaskInfo.taskId).subscribe({
       next: (taskRes: any) => {
         const taskInfo = taskRes.body || {};
    
         this.taskInfo = taskInfo;
   
         // Step 2: Fetch notes for the meeting
         this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
           next: (notes: any[]) => {
        
             this.toLinkingNotes = notes || [];
   
             // Step 3: Fetch agendas
             this.meetingService.fetchAgendaListByMeeting(id).subscribe({
               next: (agendas: any[]) => {
            
                 this.agendasinfoe = agendas || [];
                 
                 // Map notes to agendas
                 const agendasWithNotes = this.agendasinfoe.map((agenda: { agendaId: any; }) => ({
                   ...agenda,
                   notes: this.toLinkingNotes.filter((note: { agendaId: any; }) => note.agendaId === agenda.agendaId)
                 }));
            
                 // Open dialog
                 // this.dialog.open(LinkTasktonoteDialogComponent, {
                 //   data: {
                 //     meetingRes: this.toLinkingNotes,
                 //     agendas: this.agendasinfoe,
                 //     agendasWithNotes,
                 //     taskRes: this.taskInfo,
                 //     linkedNoteIds: Array.isArray(taskInfo.linkedNoteIds)
                 //       ? taskInfo.linkedNoteIds
                 //       : []
                 //   },
                 //   panelClass: ['animate__animated', 'animate__slideInLeft'],
                 //   disableClose: false,
                 //   position: { left: '0%' },
                 //   maxWidth: '100vw',
                 //   maxHeight: '100vh',
                 //   width: '50%',
                 //   height: '100vh',
                 //   autoFocus: false
                 // });
                this.dialog.open(LinkNotetotaskDialogComponent, {
                            data: {
                              meetingRes: this.toLinkingNotes,
                              agendas: this.agendasinfoe,
                              agendasWithNotes,
                              type:"TASK",
                              meetingTitle:this.meetingResponse.meetingTitle,
                              noteRes: this.taskInfo,
                              FollowupTask:this.minAttrList.isFollowUpFlag,
                              linkedNoteIds: Array.isArray(this.taskInfo.linkedTaskIds)
                                ? this.taskInfo.linkedTaskIds
                                : []
                            },
                            panelClass: ['animate__animated', 'animate__slideInLeft'],
                            disableClose: false,
                            position: { left: '0%' },
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                            width: '50%',
                            height: '100vh',
                            autoFocus: false
                          });
                        },
                        error: (err: any) => console.error('Error fetching agendas:', err)
                      });
                    },
                    error: (err: any) => console.error('Error fetching task:', err)
                  });
                },
                error: (err: any) => console.error('Error fetching notes:', err)
              });
                }
  
  
}
